module.exports = __webpack_public_path__ + "static/media/2.510138c0.jpg";